/// <reference path="../../../../../rcwebmodels/vesselstatus.cs.d.ts" />
/// <reference path="../../../../../rcwebmodels/bapliefiledata.cs.d.ts" />
import * as React from 'react';
import * as Autosuggest from 'react-autosuggest';
import { BaplieFileUpload } from './BaplieFileUpload';
import UserRights from '../../actions/UserRights';
import $ from 'jquery';

var self;
interface VesselFilters {
    Filters: server.VesselSearchFilters,
    TargetId: string,    
    VesselValue: string,
    VoyageValue: string,
    DeparturePortValue: string,
    DestinationPortValue: string,
    SuggestionsVessel: any[],
    SuggestionsVoyage: any[],
    SuggestionsDeparturePorts: any[],
    SuggestionsDestinationPorts: any[],
    popUpHtml: any;
    vesselData: server.VesselEntityCollection;
}

const initialVesselState: server.VesselSearchFilters = {
    VesselId: '',
    VoyageId: '',
    PortOfDeparture: '',
    PortOfDestination: '',
    AllReefers: ''    
};

export class VesselSearch extends React.Component<any, VesselFilters> {
    constructor(props: any) {
        super(props);  
        this.state = {
            Filters: initialVesselState,
            TargetId: '',            
            VesselValue: this.props.vesselFilters.VesselId,
            VoyageValue: this.props.vesselFilters.VoyageId,
            DeparturePortValue: this.props.vesselFilters.PortOfDeparture,
            DestinationPortValue: this.props.vesselFilters.PortOfDestination,
            SuggestionsVessel: [],
            SuggestionsVoyage: [],
            SuggestionsDeparturePorts: [],
            SuggestionsDestinationPorts: [],
            popUpHtml: '',
            vesselData: this.props.vesselData
        };  
        self = this;
    }  

    componentWillReceiveProps(nextProps: any) {
        this.setState({ vesselData: nextProps.vesselData });
    }

    getObjectArray(inputType: string) {
        var finalArray = [];

        switch (inputType) {
            case 'VesselID':
                finalArray = this.state.vesselData.VesselIDList;
                return;
            case 'VoyageID':
                finalArray = this.state.vesselData.VoyageIDList;
                return;
            case 'PortOfDeparture':
                finalArray = this.state.vesselData.PortOfDepartureList;
                return;
            case 'PortOfDestination':
                finalArray = this.state.vesselData.PortOfDestinationList;
                return;
        }

        return finalArray;
    }
    

    vesselChange(event: React.FormEvent<HTMLInputElement>) {
        var vesselfilters = this.state.Filters;
        var Value: string = event.currentTarget.value;
        vesselfilters.VesselId = Value;
        this.setState({
            Filters: vesselfilters
        });
    }

    voyageChange(event: React.FormEvent<HTMLInputElement>) {
        var vesselfilters = this.state.Filters;
        var Value: string = event.currentTarget.value;
        vesselfilters.VoyageId = Value;
        this.setState({
            Filters: vesselfilters
        });
    }

    clearFilter() { 
        this.setState({
            Filters: initialVesselState,
            TargetId: '',
            DeparturePortValue: '',
            DestinationPortValue: '',           
            SuggestionsDeparturePorts: [],
            SuggestionsDestinationPorts: [],
            VesselValue: '',
            VoyageValue: '',
            SuggestionsVessel: [],
            SuggestionsVoyage: []
        });
    }    

    applyFilter() {
        $('#vesselId').blur();
        $('#voyageId').blur();
        $('#portOfDeparture').blur();
        $('#portOfDestination').blur();

        var vesselfilters = this.state.Filters;
        vesselfilters.VesselId = this.state.VesselValue;
        vesselfilters.VoyageId = this.state.VoyageValue;
        vesselfilters.PortOfDeparture = this.state.DeparturePortValue;
        vesselfilters.PortOfDestination = this.state.DestinationPortValue;
        vesselfilters.AllReefers = "";

        if (this.state.VesselValue != '' || this.state.VoyageValue != '' || this.state.DeparturePortValue != '' || this.state.DestinationPortValue != '') {
            this.setState({
                Filters: vesselfilters
            });

            this.props.bindingVesselStatusGrid(this.state.Filters);
        }
        else {
            vesselfilters.AllReefers = "All Assets";  
              this.setState({
                Filters: vesselfilters
              });

              this.props.bindingVesselStatusGrid(this.state.Filters);
        }
    }

    getVesselSuggestions(value) {
        var targetValue = this.state.TargetId;
        var inputValue = value.trim().toLowerCase();
        var inputLength = inputValue.length;
        return (inputLength === 0 || this.state.vesselData.VesselIDList == null) ? [] : this.state.vesselData.VesselIDList.filter(VesselID =>
            VesselID.toLowerCase().slice(0, inputLength) === inputValue
        );
    }

    getVoyageSuggestions(value) {
        var targetValue = this.state.TargetId;
        var inputValue = value.trim().toLowerCase();
        var inputLength = inputValue.length;
        return (inputLength === 0 || this.state.vesselData.VoyageIDList == null) ? [] : this.state.vesselData.VoyageIDList.filter(VoyageID =>
            VoyageID.toLowerCase().slice(0, inputLength) === inputValue
        );
    }

    getDeparturePortSuggestions(value) {
        var targetValue = this.state.TargetId;
        var inputValue = value.trim().toLowerCase();
        var inputLength = inputValue.length;
        return (inputLength === 0 || this.state.vesselData.PortOfDepartureList == null) ? [] : this.state.vesselData.PortOfDepartureList.filter(PortOfDeparture =>
            PortOfDeparture.toLowerCase().slice(0, inputLength) === inputValue
        );
    }

    getDestinationPortSuggestions(value) {
        var targetValue = this.state.TargetId;
        var inputValue = value.trim().toLowerCase();
        var inputLength = inputValue.length;
        return (inputLength === 0 || this.state.vesselData.PortOfDestinationList == null) ? [] : this.state.vesselData.PortOfDestinationList.filter(PortOfDestination =>
            PortOfDestination.toLowerCase().slice(0, inputLength) === inputValue
        );
    }

    getSuggestionValue(suggestion) {
        return suggestion;
    }

    onVesselSuggestionsClearRequested = () => {
        this.setState({
            SuggestionsVessel: []
        });
    };

    onVoyageSuggestionsClearRequested = () => {
        this.setState({
            SuggestionsVoyage: []
        });
    };

    onDepartureSuggestionsClearRequested = () => {
        this.setState({
            SuggestionsDeparturePorts: []
        });
    };

    onDestinationSuggestionsClearRequested = () => {
        this.setState({
            SuggestionsDestinationPorts: []
        });
    };

    onVesselSuggestionsFetchRequested = ({ value }) => {
        this.setState({
            SuggestionsVessel: this.getVesselSuggestions(value)
        });
    };

    onVoyageSuggestionsFetchRequested = ({ value }) => {
        this.setState({
            SuggestionsVoyage: this.getVoyageSuggestions(value)
        });
    };

    onDepartureSuggestionsFetchRequested = ({ value }) => {
        this.setState({
            SuggestionsDeparturePorts: this.getDeparturePortSuggestions(value)
        });
    };

    onDestinationSuggestionsFetchRequested = ({ value }) => {
        this.setState({
            SuggestionsDestinationPorts: this.getDestinationPortSuggestions(value)
        });
    };

    onChangeVessel = (event, { newValue }) => {
        this.setState({
            VesselValue: newValue,
            TargetId: event.target.id
        });        
    };

    onChangeVoyage = (event, { newValue }) => {
        this.setState({
            VoyageValue: newValue,
            TargetId: event.target.id
        });
    };    

    onChangeDeparturePorts = (event, { newValue }) => {
        this.setState({
            DeparturePortValue: newValue,
            TargetId: event.target.id
        });
    };

    onChangeDestinationPorts = (event, { newValue }) => {
        this.setState({
            DestinationPortValue: newValue,
            TargetId: event.target.id
        });
    };

    renderSuggestion(suggestion) {
        return <span>{suggestion}</span>;
    }

    loadDataOfBaplie(baplieData: server.BaplieFileData) {
        this.setState({
            VesselValue: baplieData.VesselID,
            VoyageValue: baplieData.VoyageCode,
            DeparturePortValue: baplieData.PortOfDeparture,
            DestinationPortValue: baplieData.PortOfDestination
        });

        this.applyFilter();
    }

    BaplieFileUpload() {
        setTimeout(function () {
            self.setState({ popUpHtml: self.RenderContextMenuPopUp('BaplieFileUpload') });
        }, 10);
    }

    RenderContextMenuPopUp(popUpName: string) {
        switch (popUpName) {
            case 'BaplieFileUpload':
                return <BaplieFileUpload></BaplieFileUpload>;
        }
    }

    clearBaplieFileData() {
        BaplieFileUpload.ClearBapieStateData();
    }

    refreshVesselData() {
        this.props.refreshVesselData();
    }

    public render() {
        const { SuggestionsVessel, SuggestionsVoyage, SuggestionsDeparturePorts, SuggestionsDestinationPorts } = this.state;//, suggestionsFullName } 

        const VesselInputProps = {
            id: 'vesselId',
            placeholder: 'Enter Vessel ID',
            value: this.state.VesselValue,//  userIdvalue,
            onChange: this.onChangeVessel.bind(this)
        };

        const VoyageInputProps = {
            id: 'voyageId',
            placeholder: 'Enter Voyage ID',
            value: this.state.VoyageValue,//  userIdvalue,
            onChange: this.onChangeVoyage.bind(this)
        };

        const DepartureInputProps = {
            id: 'portOfDeparture',
            placeholder: 'Enter Port Of Departure',
            value: this.state.DeparturePortValue,//  userIdvalue,
            onChange: this.onChangeDeparturePorts.bind(this)
        };

        const DestinationInputProps = {
            id: 'portOfDestination',
            placeholder: 'Enter Port Of Destination',
            value: this.state.DestinationPortValue,
            onChange: this.onChangeDestinationPorts.bind(this)
        };

        return <div className='page-controls-container'>
            <form>
                <div className="row">
                    <div className="col-md-1 pe-0 text-md-end">
                        <label className='col-form-label'>Vessel ID:</label>
                    </div>
                    <div className="col-md-2">
                      
                            <Autosuggest name="VesselId" id="txtVesselId"
                                suggestions={SuggestionsVessel}
                                onSuggestionsFetchRequested={this.onVesselSuggestionsFetchRequested}
                                onSuggestionsClearRequested={this.onVesselSuggestionsClearRequested}
                                getSuggestionValue={this.getSuggestionValue}
                                renderSuggestion={this.renderSuggestion}
                                inputProps={VesselInputProps}
                                highlightFirstSuggestion={true}
                            />
                      
                    </div>
                    <div className="col-md-1 pe-0 text-md-end">
                        <label className='col-form-label'>Voyage ID:</label>
                    </div>
                    <div className="col-md-2">
                       
                            <Autosuggest name="VoyageId" id="txtVoyageId"
                                suggestions={SuggestionsVoyage}
                                onSuggestionsFetchRequested={this.onVoyageSuggestionsFetchRequested}
                                onSuggestionsClearRequested={this.onVoyageSuggestionsClearRequested}
                                getSuggestionValue={this.getSuggestionValue}
                                renderSuggestion={this.renderSuggestion}
                                inputProps={VoyageInputProps}
                                highlightFirstSuggestion={true}
                            />
                       
                    </div>
                    <div className="col-md-1 px-0 text-md-end">
                        <label className='col-form-label'>Port Of Departure:</label>
                    </div>
                    <div className="col-md-2">
                                                  
                            <Autosuggest name="PortOfDeparture" id="txtPortOfDeparture"
                                suggestions={SuggestionsDeparturePorts}
                                onSuggestionsFetchRequested={this.onDestinationSuggestionsFetchRequested}
                                onSuggestionsClearRequested={this.onDestinationSuggestionsClearRequested}
                                getSuggestionValue={this.getSuggestionValue}
                                renderSuggestion={this.renderSuggestion}
                                inputProps={DepartureInputProps}
                                highlightFirstSuggestion={true}
                            />
                      
                    </div>
                    <div className="col-md-1 px-0 text-md-end">
                        <label className='col-form-label'>Port of Destination:</label>
                    </div>
                    <div className="col-md-2">
                                               
                            <Autosuggest name="PortOfDestination" id="txtPortOfDestination"
                                suggestions={SuggestionsDestinationPorts}
                                onSuggestionsFetchRequested={this.onDepartureSuggestionsFetchRequested}
                                onSuggestionsClearRequested={this.onDepartureSuggestionsClearRequested}
                                getSuggestionValue={this.getSuggestionValue}
                                renderSuggestion={this.renderSuggestion}
                                inputProps={DestinationInputProps}
                                highlightFirstSuggestion={true}
                            />
                       
                    </div>
                </div>
                <div className="row mt-2">
                    <div className="col-md-9">
                    </div>
                    <div className="col-md-3">
                        <div className='hstack gap-2 float-end'>
                            <button type='button' onClick={this.clearFilter.bind(this)} className='btn btn-primary'>Clear</button>
                            <button type='button' className={'btn btn-primary hide'} data-bs-toggle="modal" data-bs-target="#baplieFileUpload" onClick={this.BaplieFileUpload.bind(this)}>Upload Baplie</button>
                            <button type='button' onClick={this.applyFilter.bind(this)} className='btn btn-primary'>Search</button>
                            
                        </div>
                    </div>
                </div>
                <div className="modal fade" id="baplieFileUpload" role="dialog">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header" id="contextMenuModelHeader">
                                <h5 className="modal-title"> Upload Baplie </h5>
                                <button type="button" className="btn-close" onClick={this.clearBaplieFileData.bind(this)}>&times;</button>
                                <button id="btnCloseBaplie" type="button" data-bs-dismiss="modal" hidden></button>                               
                            </div>
                            <div className="modal-body">
                                <BaplieFileUpload refreshVesselData={this.refreshVesselData.bind(this)}></BaplieFileUpload>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>;
    }
}
